/* Mobinova — apparitions au défilement (respecte prefers-reduced-motion) */
(() => {
  const root = document.documentElement;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
    root.classList.remove('mn-js');
    return;
  }
  const AUTO = '.mn-head, .mn-cat, .mn-faq__item, .mn-ship__row:not(.mn-ship__row--head), .mn-faq__intro, .collection-featured .product-card';
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  const init = () => {
    document.querySelectorAll(AUTO).forEach((el) => {
      if (el.closest('.mn-hs')) return;
      el.classList.add('mn-reveal');
      const siblings = [...el.parentElement.children].filter((c) => c.matches(AUTO));
      const i = siblings.indexOf(el);
      if (i > 0 && !el.style.getPropertyValue('--mn-d')) el.style.setProperty('--mn-d', Math.min(i, 6) * 70 + 'ms');
    });
    document.querySelectorAll('.mn-reveal').forEach((el) => io.observe(el));
    // filet de sécurité : tout afficher après 4 s
    setTimeout(() => document.querySelectorAll('.mn-reveal:not(.is-in)').forEach((el) => {
      if (el.getBoundingClientRect().top < innerHeight) el.classList.add('is-in');
    }), 4000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
